// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Top_wrapper__0nttk","title":"Top_title__lo4X8","text":"Top_text__BalHk","action":"Top_action__Meg1X"};